import { render, staticRenderFns } from "./headerGeneral.vue?vue&type=template&id=523f147b"
import script from "./headerGeneral.vue?vue&type=script&lang=js"
export * from "./headerGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports